import Vue from 'vue';
import InquiriesByCategory from '@/plugins/graphql/queries/v2/inquiry/inquiries-by-category.gql';
import { InquiryRequestModel } from '@/helpers/entities/models/InquiryRequestModel';
/**
 * Component for fetching App Inquiries Count and Daily Average
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.18}
 */
export default Vue.extend({
    apollo: {
        inquiriesByCategory: {
            query: InquiriesByCategory,
            variables() {
                return {
                    appUuid: this.appUuid,
                    category: this.category,
                    first: this.limit,
                };
            },
            update(data) {
                const nodes = data.latestInquiriesByCategory.edges;
                return nodes.map((inqNode) => {
                    return new InquiryRequestModel(inqNode.node);
                });
            },
            result({ data }) {
                this.totalCount = data.latestInquiriesByCategory.totalCount;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
        category: {
            type: String,
            required: true,
        },
        limit: {
            type: Number,
            default: 5,
        },
    },
    data() {
        return {
            inquiriesByCategory: null,
            totalCount: 0,
        };
    },
    computed: {
        showLinkButton() {
            const inquiries = this.inquiriesByCategory;
            const fiveRecords = 5;
            return !!inquiries && inquiries.length >= fiveRecords;
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                inquiriesByCategory: this.inquiriesByCategory,
                showLinkButton: this.showLinkButton,
                totalCount: this.totalCount,
            });
        }
    },
});
